// extracted by mini-css-extract-plugin
module.exports = {"containerLabel":"Checkbox_containerLabel__2tmPT","mark":"Checkbox_mark__1yiLM"};